<template>
    <div class="grid col-3 col-gap-2 sm-col-2 row-gap-1">
	    <search-course-card v-for="course in filtered_items" :key="course.id" :course="course"></search-course-card>
    </div>
</template>

<script>
	import SearchCourseCard from './SearchCourseCard.vue';

    export default {
        name: 'SearchCourse',

	    components: {
			'search-course-card': SearchCourseCard,
	    },

        props: {
            items: {
                required: true,
            },
            extended: {
                required: true,
                default: false,
            },
        },

        computed: {
            filtered_items() {
                if(this.extended) {
                    return this.items;
                }

                return this.items.slice(0, 3);
            },
        },

        methods: {
            isAvailable(course) {
                return course.availability.available;
            }
        }
    }
</script>